import { ConnectedRouter } from "connected-react-router";
import { Route } from "react-router-dom";
import Invoice from "containers/Invoice/Invoice";
import { ConfirmProvider } from "components/Confirm";
import SecuredLayout from "layouts/Secured";
import PublicLayout from "layouts/Public";
import "index.css";
import "akuaku.css";
import "_variables.css";
import { AkuakuProvider } from "common/AkuakuContext";
import { Tooltip } from "react-tooltip";
import { TokenResponse } from "containers/MyOrg/TokenResponse";
import { useEnvironmentPageTitle } from "common/hooks";

import Body from "./Body";

export default function App(props) {
    useEnvironmentPageTitle();

    return (
        <AkuakuProvider>
            <ConnectedRouter history={props.history}>
                <ConfirmProvider>
                    <Body>
                        <Route path="/tokenresponse" exact component={TokenResponse} />
                        <Route path="/pub" component={PublicLayout} />
                        <Route path="/invoice/:paymentId" exact component={Invoice} />
                        <Route path="/app" render={(p) => <SecuredLayout persistStore={props.persistStore} />} />
                        <Route path="/" exact render={(p) => <SecuredLayout persistStore={props.persistStore} />} />
                        <div className="help-tooltip-container">
                            <Tooltip id="help-tooltip" place="top" className="help-tooltip" style={{ zIndex: 1000 }} />
                        </div>
                    </Body>
                </ConfirmProvider>
            </ConnectedRouter>
        </AkuakuProvider>
    );
}
